module.exports = __webpack_public_path__ + "static/img/wangyi.cfa74de1.png";